// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDsvqtBhkvkwoge6Tx_cOFcH1Awkf4Y5Xk",
  authDomain: "pixel-react-5b3fb.firebaseapp.com",
  projectId: "pixel-react-5b3fb",
  storageBucket: "pixel-react-5b3fb.firebasestorage.app",
  messagingSenderId: "954095559418",
  appId: "1:954095559418:web:922d2becb51b365c465f43",
  measurementId: "G-TENZ4LCYVX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const storage = getStorage(app);
export const db = getFirestore(app);